import {
    demoFreightReference,
    formatDemoIsoDate,
    shiftDemoDate,
} from './mockDemoDates';

const freightTemplates = [
    {
        id: 17,
        daysAgo: 0,
        status: 'Open for Bids',
        origin: { city: 'Hamburg', country: 'DE' },
        destination: { city: 'Milan', country: 'IT' },
        cargo: { type: 'Electronics', weight: 24000, loadType: 'FTL' },
        bids: 12,
        verification: { verified: 8, review: 2, rejected: 2 },
    },
    {
        id: 16,
        daysAgo: 1,
        status: 'In Verification',
        origin: { city: 'Paris', country: 'FR' },
        destination: { city: 'Munich', country: 'DE' },
        cargo: { type: 'Automotive Parts', weight: 18500, loadType: 'FTL' },
        bids: 8,
        verification: { verified: 5, review: 2, rejected: 1 },
    },
    {
        id: 15,
        daysAgo: 2,
        status: 'Closed',
        origin: { city: 'Rotterdam', country: 'NL' },
        destination: { city: 'Warsaw', country: 'PL' },
        cargo: { type: 'Industrial Machinery', weight: 22000, loadType: 'FTL' },
        bids: 6,
        verification: { verified: 6, review: 0, rejected: 0 },
    },
    {
        id: 14,
        daysAgo: 2,
        status: 'Action Required',
        origin: { city: 'Barcelona', country: 'ES' },
        destination: { city: 'Lyon', country: 'FR' },
        cargo: { type: 'Chemicals', weight: 20000, loadType: 'FTL' },
        bids: 10,
        verification: { verified: 4, review: 4, rejected: 2 },
    },
    {
        id: 13,
        daysAgo: 3,
        status: 'Open for Bids',
        origin: { city: 'Milan', country: 'IT' },
        destination: { city: 'Vienna', country: 'AT' },
        cargo: { type: 'Food & Beverage', weight: 16000, loadType: 'FTL' },
        bids: 14,
        verification: { verified: 9, review: 3, rejected: 2 },
    },
    {
        id: 12,
        daysAgo: 4,
        status: 'In Verification',
        origin: { city: 'Antwerp', country: 'BE' },
        destination: { city: 'Berlin', country: 'DE' },
        cargo: { type: 'Consumer Goods', weight: 12500, loadType: 'LTL' },
        bids: 7,
        verification: { verified: 3, review: 3, rejected: 1 },
    },
    {
        id: 11,
        daysAgo: 5,
        status: 'Issues Detected',
        origin: { city: 'Frankfurt', country: 'DE' },
        destination: { city: 'Rome', country: 'IT' },
        cargo: { type: 'Pharmaceuticals', weight: 8000, loadType: 'FTL' },
        bids: 5,
        verification: { verified: 1, review: 1, rejected: 3 },
    },
    {
        id: 10,
        daysAgo: 6,
        status: 'Closed',
        origin: { city: 'Stockholm', country: 'SE' },
        destination: { city: 'Copenhagen', country: 'DK' },
        cargo: { type: 'Raw Materials', weight: 25000, loadType: 'FTL' },
        bids: 4,
        verification: { verified: 4, review: 0, rejected: 0 },
    },
];

export const buildDemoFreights = () => (
    freightTemplates.map((template) => {
        const createdAtDate = shiftDemoDate({
            days: template.daysAgo,
            hours: 9,
            minutes: 12,
        });

        const { daysAgo, ...freightData } = template;

        return {
            ...freightData,
            reference: demoFreightReference(template.id),
            createdAt: formatDemoIsoDate(createdAtDate),
        };
    })
);
